import { Alert, Box, Button, Group, Text, Title } from "@mantine/core";
import { useState } from "react";
import { Link } from "react-router";
import { AlertPresets } from "../../../../mantine/mantinePresets";
import { PUBLIC_ROUTES } from "../../../../routes";

function Paragraph6CreditLoadErrorMessage() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <Box mt="md">
      <Alert
        color={AlertPresets.error.color}
        icon={AlertPresets.error.icon}
        withCloseButton
        onClose={() => setIsVisible(false)}
      >
        <Title fw={600} order={5}>
          Gutschriften erstellen aktuell nicht möglich
        </Title>
        <Text>
          Die Funktion &quot;Gutschriften erstellen&quot; ist derzeit nicht
          verfügbar. Bitte versuchen Sie es später erneut. Besteht das Problem
          weiter, wenden Sie sich an unser Support-Team.
        </Text>
        <Group justify="flex-end" mt="md">
          <Button
            color="neutral.8"
            component={Link}
            to={PUBLIC_ROUTES.support}
            variant="outline"
          >
            Supportanfrage erstellen
          </Button>
        </Group>
      </Alert>
    </Box>
  );
}

export { Paragraph6CreditLoadErrorMessage };
